import { ApiPath } from 'common/enums/http/api-path';
import type { ResponseWithPagination } from 'common/types';
import type { FleetReplacementsHistory } from 'models/fleet-replacements-history';
import { http } from 'services/http';

export const getFleetReplacementsHistoryApi = (params?: string) =>
  http.get<ResponseWithPagination<FleetReplacementsHistory>>(
    `${ApiPath.FLEET_REPLACEMENTS_HISTORY}${params}`
  );
